const _cusmoize = {
  'name': '',
  'quantity': 1,
  'sections': [
    {
      'id': 1,
      'label': 'BREAD',
      'multi': 1,
      'selected': [],
      'items': [
        {
          'id': 1,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-italian.png',
          'name': 'Italian'
        },
        {
          'id': 2,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-heartyitalian.png',
          'name': 'Hearty Italian'
        },
        {
          'id': 3,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-wheat.png',
          'name': 'Multi Grain'
        },
        {
          'id': 4,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-oats.png',
          'name': 'Honey Oats'
        },
        {
          'id': 5,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-oregano.png',
          'name': 'Parmesan Oregano'
        },
        {
          'id': 6,
          'parentid': 1,
          'icon': '../../static/img/MenuOptions/bread/img-bread-flatbread.png',
          'name': 'Flat Bread'
        }
      ]
    },
    {
      'id': 2,
      'label': 'VEGGIE',
      'multi': 0,
      'selected': [],
      'items': [
        {
          'id': 1,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-lettuce.png',
          'name': 'Lettuce'
        },
        {
          'id': 2,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-tomatoes.png',
          'name': 'Tomatoes'
        },
        {
          'id': 3,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-onions.png',
          'name': 'Onions'
        },
        {
          'id': 4,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-pickles.png',
          'name': 'Pickles'
        },
        {
          'id': 5,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-cucumber.png',
          'name': 'Cucumber'
        },
        {
          'id': 6,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-capsicum.png',
          'name': 'Capsicum'
        },
        {
          'id': 7,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-black-olives-sliced.png',
          'name': 'Olives'
        },
        {
          'id': 8,
          'parentid': 2,
          'icon': '../../static/img/MenuOptions/veggie/img-jalapeno.png',
          'name': 'Jalapenos'
        },
        {
          'id': 9,
          'parentid': 2,
          'icon': '',
          'name': 'No Veggie'
        }
      ]
    },
    {
      'id': 3,
      'label': 'SAUCES',
      'multi': 2,
      'selected': [],
      'items': [
        {
          'id': 1,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_Caesar.png',
          'name': 'Caesar'
        },
        {
          'id': 2,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_Chipotle.png',
          'name': 'Chipotle'
        },
        {
          'id': 3,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_HoneyMustard.png',
          'name': 'Honey Mustart'
        },
        {
          'id': 4,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_Ketchup.png',
          'name': 'Ketchup'
        },
        {
          'id': 5,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_Mayo.png',
          'name': 'Mayo'
        },
        {
          'id': 6,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_Mustard.png',
          'name': 'Mustard'
        },
        {
          'id': 7,
          'parentid': 3,
          'icon': '../../static/img/MenuOptions/sauces/img_SweetOnion.png',
          'name': 'Sweet Onion'
        },
        {
          'id': 8,
          'parentid': 3,
          'icon': '',
          'name': 'No Sauces'
        }
      ]
    }
  ]
}
export default {
  getCusmoizes (cb) {
    cb(_cusmoize)
  }
}



// WEBPACK FOOTER //
// ./src/api/customize.js